import { useMemo } from 'react';
import { FEATURE_FLAGS } from '~/constants';
import { useGetSavedLists } from '~/hooks/api/useSavedLists';
import { useFeature } from '~/hooks/useFeatureFlag/useFeature';
import { SAVED_LIST_PAGESIZE } from '~/screens/SavedListsScreen/SavedListsScreen.constants';

const useGetSavedList = (enableAgencyLists: boolean) => {
  return useGetSavedLists({
    enableAgencyLists,
    pageSize: SAVED_LIST_PAGESIZE,
    saved: true,
  });
};

export const useHasSavedList = () => {
  const { isEnabled: isEnabledFoamSavedListAgencies } = useFeature(
    FEATURE_FLAGS.foamSavedListAgencies,
  );
  const { data: agencySavedList } = useGetSavedList(
    isEnabledFoamSavedListAgencies,
  );
  const { data: rosterSavedList } = useGetSavedList(false);

  const hasSavedLists = useMemo(
    () =>
      Boolean(
        agencySavedList?.results?.length || rosterSavedList?.results?.length,
      ),
    [agencySavedList?.results?.length, rosterSavedList?.results?.length],
  );
  return hasSavedLists;
};
